import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'underscore';
import { CropYear } from '../../models/cropYear';
import { CropYearService } from '../../services/crop-year.service';

@Component({
  selector: 'crop-year-dropdown',
  templateUrl: './crop-year-dropdown.component.html',
  styleUrls: ['./crop-year-dropdown.component.scss']
})
export class CropYearDropdownComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Output() cropYear = new EventEmitter<CropYear>();
  @Input() cropYearInput: number;

  public selectedCropYear: CropYear;
  public cropYearList: CropYear[] = [];

  constructor(
    private cropYearService: CropYearService,
  ) { }


  ngOnInit() {
    // Include inactive crop years so a load already assigned to a closed-out
    // crop year still matches below, instead of falling back to the current year.
    this.cropYearService.getCropYears(!!this.cropYearInput).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x => {

      if (this.cropYearInput) {
        // Each crop has its own CropYear row per calendar year (see CropYear.cropId),
        // so multiple crops can have a row for e.g. year 2024 with different ids.
        // Scope the list to the input's own crop instead of deduping by year across
        // all crops - otherwise a different crop's same-year row can win the dedup,
        // the id match below fails, and the wrong crop year gets silently selected.
        const inputYear = _.find(x, y => y.id === this.cropYearInput);
        if (inputYear) {
          x = x.filter(y => y.cropId === inputYear.cropId);
        }
        this.cropYearList = _.sortBy(x, 'year').reverse();
      } else {
        x = _.sortBy(x, 'year').reverse();
        this.cropYearList = _.uniq(x, function(item) { return item.year; });
      }

      this.applySelection();
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cropYearInput'] && this.cropYearList.length > 0) {
      this.applySelection();
    }
  }

  private applySelection() {
    if (this.cropYearInput) {
      const match = _.find(this.cropYearList, y => y.id === this.cropYearInput);
      if (match) {
        this.selectedCropYear = match;
        this.cropYear.emit(this.selectedCropYear);
      }
      // If a specific crop year was requested but not found, do nothing rather
      // than silently falling back to the current year - that previously
      // overwrote the caller's real cropYearId (e.g. on load edit save).
      return;
    }
    const currentYear = _.find(this.cropYearList, y => y.isCurrentYear);
    if (currentYear) {
      this.selectedCropYear = currentYear;
      this.cropYear.emit(this.selectedCropYear);
    }
  }

  emitCropYear() {
    this.cropYear.emit(this.selectedCropYear);
  }

}
